/**
 * Дробная высота без округления: offsetHeight/round дают целые px, а реальный блок
 * + сумма translateY накапливают субпиксель — на zoom≠100% это превращается в «зазоры».
 * borderBoxSize из ResizeObserver совпадает с тем, что отдаёт RO в виртуализаторе.
 */
export function measureTableVirtualRowElement(element: Element, entry: ResizeObserverEntry | undefined): number {
  const box = entry?.borderBoxSize?.[0];
  if (box && typeof box.blockSize === 'number') {
    return box.blockSize;
  }
  return element.getBoundingClientRect().height;
}
